import { useParams } from "react-router-dom";

import { Layout } from "Layout";

import { ListPage } from "components/ListPage/ListPage";

import { i18n } from "services/i18nService";

import { useEditModal } from "hooks/useEditModal";
import { usePrivileges } from "hooks/usePrivileges";

import { Forbidden } from "Forbidden";
import { USER_PRIVILEGE, OBJECT_TYPES } from "appConstants";

const objectType = OBJECT_TYPES.INVOICE.fullString;

export function InvoiceList() {
  const { hasPrivilegesOrIsAdmin } = usePrivileges();
  const { id } = useParams();

  useEditModal(objectType, id);

  const allowList = hasPrivilegesOrIsAdmin([
    USER_PRIVILEGE.viewInvoices,
    USER_PRIVILEGE.editInvoices,
  ]);

  return (
    <Layout pageTitle={i18n(`objectType.${objectType}.SentencePlural`)}>
      {allowList ? <ListPage objectType={objectType} /> : <Forbidden />}
    </Layout>
  );
}
